import React, { useState, useEffect } from "react";
import DataSummaryGraph from "../DataGraph/DataSummaryGraph";
import DataSummaryGraphTableLegend from "../DataGraph/DataSummaryGraphTableLegend";
import { CircularProgress } from "@mui/material";
import _ from "lodash";

const ReportsIndex = ({ loading, data }) => {
  const [legendData, setLegendData] = useState({
    dataInner: null,
    dataOuter: null,
  });

  const [graphPointerEvent, setGraphPointerEvent] = useState(true);
  const [noMatchData, setNoMatchData] = useState(true);
  const [dataInner, setDataInner] = useState([]);
  const [dataOuter, setDataOuter] = useState([]);
  const [activeIndex, setActiveIndex] = useState(undefined);


  useEffect(() => {
    if (data.length < 0) {
      setNoMatchData(true)
      return
    }
    setNoMatchData(false)
    let array_data = _.sortBy(data[0], ["genus", "species"]);
    array_data = array_data.map((cur, index) => {
      return {
        ...cur,
        genus: _.capitalize(cur.genus),
        visible: true,
        fullSpecies: _.capitalize(cur.genus) + " " + cur.species,
      };
    });
    computeSelectedData(array_data);
  }, [data])

  const legendItemStyle = { cursor: "pointer" };

  const toggleVisible = (entry, isInner) => {
    const matchKey = entry.name;
    let filteredData = data.map((cur) => {
      if (
        !isInner &&
        cur.fullSpecies.endsWith(entry.genus + " " + entry.name)
      ) {
        return {
          ...cur,
          visible: !cur.visible,
        };
      } else if (isInner && cur.fullSpecies.startsWith(matchKey)) {
        return {
          ...cur,
          visible: !cur.visible,
        };
      }
      return cur;
    });
    computeSelectedData(filteredData);
  };

  const toggleVisibleAll = () => {
    computeSelectedData(
      data.map((cur) => {
        return {
          ...cur,
          visible: !cur.visible,
        };
      })
    );
  };
  const clearVisible = () => {
    computeSelectedData(
      data.map((cur) => {
        return {
          ...cur,
          visible: true,
        };
      })
    );
  };

  const computeSelectedData = (filteredData) => {
    let data1 = [],
      data2 = [],
      order = 0,
      array = [];
    for (let i of filteredData) {
      data2.push({
        ...i,
        name: i.species,
        value: i.count,
        genus: _.capitalize(i.genus),
      });
      if (data1[i?.genus]) {
        data1[i.genus] = {
          ...i,
          ...data1[i.genus],
          value: data1[i.genus].value + i.count,
        };
      } else {
        data1[i.genus] = {
          ...i,
          name: _.capitalize(i.genus),
          value: i.count,
          order: order,
        };
        order += 1;
      }
    }
    for (var i in data1) {
      array.push(data1[i]);
    }
    setDataOuter(data2.filter((cur) => cur.visible));
    setDataInner(
      array
        .filter((cur) => cur.visible)
        .sort((a, b) => parseFloat(a.order) - parseFloat(b.order))
    );
    setLegendData({
      dataOuter: data2,
      dataInner: array.sort(
        (a, b) => parseFloat(a.order) - parseFloat(b.order)
      ),
    });
  };

  return (
    <div style={{ display: "flex" }}>
      <div
        style={{
          flexBasis: "50%",
          justifyContent: "center",
          marginTop: "0px",
          marginLeft: "50px",
          position: "relative",
        }}
      >
        {loading ? (
          <div
            style={{
              textAlign: "center",
              marginTop: "20vh",
              alignItems: "center",
              justifyContent: "center",
              height: "100%",
              width: "100%",
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: 1,
            }}
          >
            <CircularProgress size={"2rem"} id={"loading-tray"} />
          </div>
        ) : (
          <DataSummaryGraph
            setLegendData={setLegendData}
            pointerEvent={graphPointerEvent}
            dataInner={dataInner}
            dataOuter={dataOuter}
            noMatchData={noMatchData}
            activeIndex={activeIndex}
            setActiveIndex={setActiveIndex}
          />
        )}
      </div>

      <div
        style={{
          flexBasis: "50%",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        {legendData?.dataInner && (
          <DataSummaryGraphTableLegend
            dataInner={legendData.dataInner}
            dataOuter={legendData.dataOuter}
            setPointerEvent={setGraphPointerEvent}
            toggleVisible={toggleVisible}
            toggleVisibleAll={toggleVisibleAll}
            clearVisible={clearVisible}
            style={legendItemStyle}
          />
        )}
      </div>
    </div>
  );
};

export default ReportsIndex;
